import React from 'react';
import gql from 'graphql-tag';
import { curry, get } from 'lodash';
import { Query } from 'react-apollo';

import { RequestLineFieldsFragment } from '../constants';

export const NAME = 'compositions_CaseRequestPanel_CaseRequestLines';

export const query = gql`
  query ${NAME} ($caseNumber: String!) {
    case(caseNumber: $caseNumber) {
      id
      fixpixPushResult
      requestLines { ...RequestLineFields }
      requestAgreementLines {
        agreed
        agreementLine { ...RequestLineFields }
        requestLineId
      }
      suppliedLines {
        supplied
        suppliedLine { ...RequestLineFields }
        agreementLineId
      }
    }
  }
  ${RequestLineFieldsFragment}
`;

export const buildQueryChild = curry(
  (WrappedComponent, componentProps, { data, loading }) => {
    const caseId = get(data, 'case.id');
    const requestLines = get(data, 'case.requestLines', []);
    const requestAgreementLines = get(data, 'case.requestAgreementLines', []);
    const requestSuppliedLines = get(data, 'case.suppliedLines', []);

    return (
      <WrappedComponent
        {...componentProps}
        caseId={caseId}
        requestLines={requestLines}
        requestAgreementLines={requestAgreementLines}
        requestSuppliedLines={requestSuppliedLines}
        isLoadingRequestLines={!!loading}
      />
    );
  },
);

const withCaseRequestLines = WrappedComponent => componentProps => {
  const { caseNumber } = componentProps;
  return (
    <Query
      query={query}
      skip={!caseNumber}
      fetchPolicy="network-only"
      variables={{ caseNumber }}
    >
      {buildQueryChild(WrappedComponent, componentProps)}
    </Query>
  );
};

export default withCaseRequestLines;



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestsPanelContext/withCaseRequestLines/index.js